import { strToU8, zipSync } from 'fflate';

import type { PurchaseOrderExcelFile } from '@kaiizen/kai-pro-api-react-state';

import { formatCsv } from '@/Client/Lib';

export type PurchaseOrderLeftOut = { query: string; address?: string; reason: string };

export const NOT_INCLUDED_CSV_FILENAME = 'NOT_INCLUDED.csv';

/** The purchase order files as one zip, plus a NOT_INCLUDED.csv listing each query left out and why. */
export const buildPurchaseOrdersZip = (files: PurchaseOrderExcelFile[], leftOut: PurchaseOrderLeftOut[]) => {
  const notIncludedCsv = formatCsv([['query', 'address', 'reason'], ...leftOut.map(({ query, address, reason }) => [query, address ?? '', reason])]);
  const zipped = zipSync({
    ...Object.fromEntries(files.map(({ filename, data }) => [filename, data])),
    ...(leftOut.length ? { [NOT_INCLUDED_CSV_FILENAME]: strToU8(notIncludedCsv) } : {}),
  });
  return new Blob([zipped as BlobPart], { type: 'application/zip' });
};
